var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { Sounds } from '../../lib/sounds';
import { choose } from '../../lib/util';
import { buttonStyles } from '../button';
let CharacterCustomizerComponent = class CharacterCustomizerComponent extends LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.hairColor = choose(['Black', 'Brown', 'Blonde'], Math.random);
        this.hairStyle = choose(['Poofy', 'Pointy', 'Bald'], Math.random);
        this.skinTone = choose(['Light', 'Medium', 'Dark'], Math.random);
        this.clothing = choose(['Blue', 'Green'], Math.random);
        this.track = '';
    }
    get nameValid() {
        return this.name != undefined && this.name.length > 0;
    }
    render() {
        const playerInfo = {
            player: this.name,
            hairColor: this.hairColor,
            hairStyle: this.hairStyle,
            skinTone: this.skinTone,
            clothing: this.clothing,
            songTrack: this.track,
        };
        const nameValid = this.nameValid;
        return html `
            <h2>Character Creator</h2>
            <player-canvas .player=${playerInfo}></player-canvas>
            <div class="form">
                <div class="form-row">
                    <label for="name">Name:&nbsp;</label>
                    <input
                        type="text"
                        class="text-box"
                        id="name"
                        name="name"
                        required
                        .value=${this.name}
                        @input=${(e) => {
            this.name = e.target.value;
        }}
                    />
                </div>
                <div class="form-row">
                    <label for="hair-color">Hair Color:&nbsp;</label>
                    <select
                        id="hair-color"
                        class="select-box"
                        name="hair-color"
                        @change=${(e) => {
            this.hairColor = e.target.value;
        }}
                    >
                        <option value="Black" ?selected=${this.hairColor === 'Black'}>Black</option>
                        <option value="Brown" ?selected=${this.hairColor === 'Brown'}>Brown</option>
                        <option value="Blonde" ?selected=${this.hairColor === 'Blonde'}>
                            Blonde
                        </option>
                    </select>
                </div>
                <div class="form-row">
                    <label for="hair-style">Hair Style:&nbsp;</label>
                    <select
                        id="hair-style"
                        class="select-box"
                        name="hair-style"
                        @change=${(e) => {
            this.hairStyle = e.target.value;
        }}
                    >
                        <option value="Poofy" ?selected=${this.hairStyle === 'Poofy'}>Poofy</option>
                        <option value="Pointy" ?selected=${this.hairStyle === 'Pointy'}>
                            Pointy
                        </option>
                        <option value="Bald" ?selected=${this.hairStyle === 'Bald'}>Bald</option>
                    </select>
                </div>
                <div class="form-row">
                    <label for="skin-tone">Skin Tone:&nbsp;</label>
                    <select
                        id="skin-tone"
                        class="select-box"
                        name="skin-tone"
                        @change=${(e) => {
            this.skinTone = e.target.value;
        }}
                    >
                        <option value="Light" ?selected=${this.skinTone === 'Light'}>Light</option>
                        <option value="Medium" ?selected=${this.skinTone === 'Medium'}>
                            Medium
                        </option>
                        <option value="Dark" ?selected=${this.skinTone === 'Dark'}>Dark</option>
                    </select>
                </div>
                <div class="form-row">
                    <label for="clothing">Clothing:&nbsp;</label>
                    <select
                        id="clothing"
                        class="select-box"
                        name="clothing"
                        @change=${(e) => {
            this.clothing = e.target.value;
        }}
                    >
                        <option value="Blue" ?selected=${this.clothing === 'Blue'}>Blue</option>
                        <option value="Green" ?selected=${this.clothing === 'Green'}>Green</option>
                    </select>
                </div>
                <div class="form-row">
                    <label for="track">Music Layer:&nbsp;</label>
                    <select
                        id="track"
                        class="select-box"
                        name="track"
                        @change=${(e) => {
            this.track = e.target.value;
            Sounds.setSongs([this.track]);
        }}
                    >
                        <option value="" ?selected=${this.track === ''}>---</option>
                        <option value="melody" ?selected=${this.track === 'melody'}>Melody</option>
                        <option value="bass" ?selected=${this.track === 'bass'}>Bass</option>
                        <option value="drums" ?selected=${this.track === 'drums'}>Drums</option>
                        <option value="chords" ?selected=${this.track === 'chords'}>Chords</option>
                    </select>
                    <p>Other players will hear this layer when they summon you</p>
            </div>
            <button
                class="go-button button"
                ?disabled=${!nameValid || this.track.length == 0}
                @click=${() => {
            this.dispatchEvent(new CustomEvent('select-customization', {
                detail: playerInfo,
                bubbles: true,
                composed: true,
            }));
        }}
            >
                Go!
            </button>
        `;
    }
};
CharacterCustomizerComponent.styles = [
    buttonStyles,
    css `
        :host {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        label {
            font-weight: bold;
        }

        player-canvas {
            width: 30vmin;
            height: 30vmin;
        }

        .form {
            margin-top: 20px;
        }

        .form-row {
            margin: 8px 0;
        }

        .go-button {
            margin-top: 20px;
        }

        p {
            margin: 4px 0;
        }

        p, label {
            color: #ead4aa;
        }

        h2 {
            color: #f0e3c9;
        }

        player-canvas {
            padding: 0 0 10px;
            background-color: #ead4aa;
            box-shadow: 0 10px #21151b;
            border-radius: 10px;
        }

        .text-box {
            background-color: #ead4aa;
            border: 3px solid #21151b;
            border-radius: 6px;
            padding: 6px 8px 4px;
            font-family: inherit;
            font-size: 16px;
        }

        .select-box {
            background-color: #ead4aa;
            border: 2px solid #21151b;
            border-radius: 6px;
            padding: 2px 4px 0px;
            font-family: inherit;
            font-size: 16px;
        }
    `
];
__decorate([
    state()
], CharacterCustomizerComponent.prototype, "name", void 0);
__decorate([
    state()
], CharacterCustomizerComponent.prototype, "hairColor", void 0);
__decorate([
    state()
], CharacterCustomizerComponent.prototype, "hairStyle", void 0);
__decorate([
    state()
], CharacterCustomizerComponent.prototype, "skinTone", void 0);
__decorate([
    state()
], CharacterCustomizerComponent.prototype, "clothing", void 0);
__decorate([
    state()
], CharacterCustomizerComponent.prototype, "track", void 0);
CharacterCustomizerComponent = __decorate([
    customElement('character-customizer')
], CharacterCustomizerComponent);
export { CharacterCustomizerComponent };
